import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { useSelector } from "react-redux";
import TableRowLevels from "./TableRowLevels";
import TableRowViewLC from "./TableRowViewLC";
import TableRowViewGeneral from "./TableRowViewGeneral";

const TableGuttmanChart = ({ students, lcs, loading, completed, completedType }) => {
  const studentsLoading = useSelector(
    (state) => state?.classMarking?.studentsLoading
  );

  const currentCurriculum = useSelector(
    (state) => state?.assessment?.currentCurriculum || {}
  );
  const view = useSelector(
    (state) => state?.classMarking.viewGuttmanChart || "general"
  );
  const marking = currentCurriculum?.marking || [];
  const levels = currentCurriculum?.levels || [];
  const size = 27;

  return (
    <TableContainer className="absolute inset-0 flex flex-col">
      <Table className="w-fit">
        <TableBody>
          {view === "learning-continuum" && (
            <TableRowLevels
              lcs={lcs}
              levels={levels}
              currentCurriculum={currentCurriculum}
              size={size}
            />
          )}
          {view === "learning-continuum" &&
            [...students]
              .sort((a, b) =>  Number(b?.[completedType]) -  Number(a?.[completedType]))
              .map((student, index) => {
                return (
                  <TableRowViewLC
                    key={`guttman-chart-table-student-${student._id}`}
                    completed={completed}
                    student={student}
                    lcs={student.lcs || lcs}
                    marking={marking}
                    levels={levels}
                    index={index}
                    currentCurriculum={currentCurriculum}
                    size={size}
                    isLoading={studentsLoading || loading}
                  />
                )
              })}
          {view === "general" &&
            [...students]
            .sort((a, b) => Number(b?.[completedType]) -  Number(a?.[completedType]))
            .map((student, index) => {
                const lcs2 = student?.lcs || lcs;
                const granularSteps = [];
                lcs2?.forEach((lc) => {
                  lc.granularSteps.forEach((gs) => {
                    if (gs.isLevel && gs.definition) {
                      granularSteps.push({
                        ...gs,
                        lcId: lc._id,
                        lc
                      });
                    }
                  });
                });

                return (
                  <TableRowViewGeneral
                    key={`guttman-chart-table-student-${student._id}`}
                    student={student}
                    lcs={student.lcs || lcs}
                    completed={completed}
                    granularSteps={granularSteps.sort((a, b) => {
                      if (a?.[completedType] === b?.[completedType]) {
                        return a.position - b.position;
                      }

                      return a?.[completedType] - b?.[completedType];
                    }).reverse()}
                    marking={marking}
                    levels={levels}
                    index={index}
                    currentCurriculum={currentCurriculum}
                    size={size}
                    isLoading={studentsLoading || loading}
                  />
                );
              })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableGuttmanChart;
